import React, {useEffect} from 'react';
import {useFormik} from 'formik';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import * as yup from 'yup';
import actions from '../../../redux/actions';
import {connect} from 'react-redux';
import _ from 'lodash';
import './ResetPassRequest.scss';
import {useHistory} from 'react-router-dom';

const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.touched, name ) && _.get( formik.errors, name ) }
        </div>
    );
};

const ResetPassRequest = ({resetPassEmail, resetPasswordEmailState, cleanResetPassEmailState, showSidebar}) => {
    const history = useHistory();

    const validationSchema = yup.object({
        email: yup
            .string('Ingrese email')
            .email('email invalido')
            .required('Ingrese email'),
    });

    useEffect(() => {
        if (resetPasswordEmailState?.success) {
          history.replace('/login');
          cleanResetPassEmailState();
        }
        // eslint-disable-next-line
    }, [resetPasswordEmailState?.success]);

    const formik = useFormik({
        initialValues: {
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const body = {
                email: values.email,
            };
            resetPassEmail(body);
        },
    });

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <div className="chp-div-section">

                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">Pedir cambio de contraseña</p>
                        <hr id="id-hr"/>
                    </div>
                </div>

                <div className="ul-div-form">

                    <form className="eu-form" onSubmit={formik.handleSubmit}>

                        <div className="eu-div-container">
                            <div className="eu-div-input">
                                <text className="eu-text-l eu-f-label">Email</text>
                            </div>
                            <div className="eu-div-input">
                                <input
                                    className="rp-input-l" name="email" value={formik.values.email}
                                    onChange={formik.handleChange}
                                />
                            </div>
                            <div className="eu-div-input">
                                <InputErrorMessage formik={formik} name='email' className='rp-input-l' />
                            </div>

                            <Ebutton classNameButton="eu-btn" type="submit" text="Enviar Email"/>
                        </div>

                    </form>
                </div>

            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    resetPasswordEmailState: state.login.resetPasswordEmailState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    resetPassEmail: (body) => dispatch(actions.login.resetPassEmailRequest(body)),
    logout: () => dispatch(actions.login.logout()),
    cleanResetPassEmailState: () => dispatch(actions.login.cleanResetPassEmailState()),
});


export default connect(mapStateToProps, mapDispatchToProps)(ResetPassRequest);
